import React from 'react';
import { Col, Row, Container } from 'reactstrap';
import CountdownTimer from './../../Global/Header/CountdownTimer';

const Eliminar = () => {
  return (
    <Col xs={12} className="homeContainer">
      <CountdownTimer/>
      <Row>
        <Container className="bg-primary">
          <section className="border mb-4 px-4 pb-4 back-white border-container eliminar-style">
            <h2>
                Cuenta eliminada
            </h2>
            <p>
                Lamentamos que nos dejes, pero siempre que desees volver te estaremos esperando con los brazos abiertos.
            </p>
            <a class="button-rounded button-rounded-blue d-inline-block align-middle w-85" href="/">
              <div class="center-right-button">
                <span>
                  <strong>
                    Regresar al inicio
                  </strong>
                </span>
              </div>
            </a>
          </section>
        </Container>
      </Row>
    </Col>

  );
};

export default Eliminar;
